import type { ReactNode } from "react";

import { useOutgoingRequest } from "../data/tanstack-query";
import { getMe } from "../endpoints/outgoing-requests";
import type { Permission } from "../enums/Permission";
import Await from "./async/Await";

type OnlyWithPermissionProps = {
    permission: Permission;
    children: ReactNode;
};

export default function OnlyWithPermission(props: OnlyWithPermissionProps) {
    return (
        <Await loading={Empty}>
            <OnlyWithPermissionCheck {...props} />
        </Await>
    );
}

function OnlyWithPermissionCheck(props: OnlyWithPermissionProps) {
    const { permission, children } = props;
    const me = useOutgoingRequest(getMe());
    if (!me.hasPermission(permission)) return null;
    return children;
}

function Empty() {
    return null;
}
